import { addIndex, isNil, map, pipe, prop } from 'ramda';
import { v4 as uuidv4 } from 'uuid';

const mapIndexed = addIndex(map);

const prevIsCompleted = (currentIndex, process) => {
	if (currentIndex === 0) return true;
	const prev = prop(currentIndex - 1, process);
	if (!isNil(prev)) {
		return pipe(prop('status'), val => !!val)(prev);
	}
	return false;
};

export const parseProcesses = process => mapIndexed(
	(supply, index) => ({
		id: uuidv4(),
		name: prop('title', supply),
		urlImage: prop('urlImage', supply),
		completed: pipe(prop('status'), val => !!val)(supply),
		enabled: prevIsCompleted(index, process),
		description: prop('description', supply),
		instructions: prop('instructions', supply),
		goTo: prop('goTo', supply),
	}),
	process,
);

export default {};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/utils/processes/processes.js